import React, { FC } from 'react';
import cn from '../../../../utils/classnames';
import { DropdownOption } from '../../dropdown';
import useDropdownContext from '../../hooks/use-dropdown-context';
import './dropdown-item.scss';

type LiType = React.DetailedHTMLProps<React.LiHTMLAttributes<HTMLLIElement>, HTMLLIElement>;
type DropdownItemProps = Omit<LiType, 'aria-selected' | 'role'> & {
    selected?: boolean;
    disabled?: boolean;
    option?: DropdownOption;
    children: React.ReactNode;
};

const DropdownItem: FC<DropdownItemProps> = (props) => {
    const { className, selected, disabled, children, onClick, option, ...liProps } = props;
    const { onItemSelect } = useDropdownContext();

    const handleClick = (e: React.MouseEvent<HTMLLIElement>) => {
        if (disabled) {
            e.stopPropagation();
            e.preventDefault();

            return;
        }

        onItemSelect(option, e);
        onClick?.(e);
    };

    return (
        <li
            id={String(option?.id || '')}
            role='option'
            className={cn('dropdown-item', className, { disabled })}
            aria-selected={selected}
            aria-disabled={disabled}
            onClick={handleClick}
            data-testid={option?.['data-testid']}
            {...liProps}
        >
            {children}
        </li>
    );
};

export default DropdownItem;
